import API_URLS from "constants/apis.url";

import { getRequest } from "./api";

const CIP_URL = API_URLS.cipURL;

export const getCipPrediction = () => getRequest(`/prediction${CIP_URL}`);
export const getCipCleaning = () => getRequest(`${CIP_URL}/cleaning`);
export const getFoulingTypes = () => getRequest(`${CIP_URL}/fouling`);
export const getMembranePrediction = () => getRequest(`${API_URLS.membranePrediction}`);
